import React, { useState, useEffect } from 'react';
import "./styles.css";
import getFilterCount  from "../../utils/getFilterCount";
import Cookies from 'js-cookie';

const TopBarFilter = ({ onFilterChange, data }) => {
  const [filter, setFilter] = useState('');
  const [stateToken, setStateToken] = useState('');
  const [statusCount, setStatusCount] = useState('');

  console.log('TopBar DATA: ' + JSON.stringify(data))
  const filteredData = data.filter(obj => obj.botStatus === 1)
  console.log('TopBar DATA parsing: ' + filteredData.length)


  
  // useEffect(() => {
  //   async function filterCount() {
  //     let token = await getToken()
  //     let response = await getFilterCount(
  //       token
  //     )
  //     console.log('statusCountstatusCountstatusCountstatusCount', response)
  //     setStatusCount([response])      
  //   }

  //   filterCount()
	// }, []);


  
  const handleFilterChange = (newFilter) => {
    setFilter(newFilter);
    onFilterChange(newFilter);
  };

  const getToken = async () => {
		const cookieToken = Cookies.get('_auth');
		console.log('getTokenAAAAAAAAAA', cookieToken);
		// setStateToken(cookieToken)
    return cookieToken
	}

  // const filterCount = async (status) => {
  //   await getToken()
  //   let data = await getFilterCount(
	// 		stateToken
	// 	)

  //   console.log('filterCount result:', data)

  //   setStatusCount(data)

  //   // switch (status) {
  //   //   case 'all':
  //   //     return data.filter(obj => obj._id === null);
  //   //   case 'open':
  //   //     return data.filter(obj => obj._id === 1);
  //   //   case 'pending':
  //   //     return data.filter(obj => obj._id === 2);
  //   //   case 'closed':
  //   //     return data.filter(obj => obj._id === 3);
  //   //   default:
  //   //     return 0
  
  //   // }

  // };



  return (
    <div className="top-bar-filter">
      <button
        className={`filter-btn ${filter === 'all' ? 'active' : ''}`}
        onClick={() => handleFilterChange('all')}
      >
        {/* All({
          statusCount[0]?
          statusCount[0].length > 0 ? statusCount[0].filter(obj => obj._id === null).length > 0 ? statusCount[0].filter(obj => obj._id === null)[0].count : 0 : 0
            : 0
          }) */}

        All({
                data?
                data.length > 0 ? data.filter(obj => obj.botStatus === null).length > 0 ? data.filter(obj => obj.botStatus === null).length : 0 : 0
                  : 0
        })
         
 
      </button>
      <button
        className={`filter-btn ${filter === 'open' ? 'active' : ''}`}
        onClick={() => handleFilterChange('open')}
      >
        {/* Open({
          statusCount[0]?
            statusCount[0].length > 0 ? statusCount[0].filter(obj => obj._id === 1).length > 0 ? statusCount[0].filter(obj => obj._id === 1)[0].count : 0 : 0
            : 0
        }) */}
        Open({
                data?
                data.length > 0 ? data.filter(obj => obj.botStatus === 1).length > 0 ? data.filter(obj => obj.botStatus === 1).length : 0 : 0
                  : 0
        })
      </button>

      <button
        className={`filter-btn ${filter === 'pending' ? 'active' : ''}`}
        onClick={() => handleFilterChange('pending')}
      
      >
        {/* Pending({
          statusCount[0]?
          statusCount[0].length > 0 ? statusCount[0].filter(obj => obj._id === 2).length > 0 ? statusCount[0].filter(obj => obj._id === 2)[0].count : 0 : 0
            : 0
        }) */}
        Pending({
                data?
                data.length > 0 ? data.filter(obj => obj.botStatus === 2).length > 0 ? data.filter(obj => obj.botStatus === 2).length : 0 : 0
                  : 0
        })
      </button>

      <button
        className={`filter-btn ${filter === 'closed' ? 'active' : ''}`}
        onClick={() => handleFilterChange('closed')}
       
      >
        {/* Closed ({
          statusCount[0]?
          statusCount[0].length > 0 ? statusCount[0].filter(obj => obj._id === 3).length > 0 ? statusCount[0].filter(obj => obj._id === 3)[0].count : 0 : 0
            : 0
        }) */}
        Closed({
                data?
                data.length > 0 ? data.filter(obj => obj.botStatus === 3).length > 0 ? data.filter(obj => obj.botStatus === 3).length : 0 : 0
                  : 0
        })
      </button>

    </div>
  );
};

export default TopBarFilter;
